export default __webpack_public_path__ + "static/media/avatar.77aef335.png";